'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    LoginWidgetController.$inject = ['$rootScope', '$uibModal', 'authService', 'localStorageService'];
    angular.module('app.dashboard').component('loginWidget', {
        require: { app: "^app" },
        template: '<style>\n    .login-widget {\n        padding: 8px 15px;\n        margin-bottom: 20px;\n        background-color: #dfdfdf;\n        border-radius: 4px;\n    }\n</style><div class="login-widget" ng-if="$ctrl.app.authUser" translate-namespace="admin.login"><span translate>.Welcome,</span> {{$ctrl.app.authUser.email}} | <a ng-click="$ctrl.onLogout()"><span translate>.Logout</span></a></div>',
        controller: LoginWidgetController,
        controllerAs: '$ctrl'
    });

    function LoginWidgetController($rootScope, $uibModal, authService, localStorageService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {
            authService.hasValidToken().then(function (r) {}).catch(function (error) {
                $ctrl.onLogout();
            });
        };

        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        $ctrl.onLogout = function () {
            $rootScope.$emit('user.logout');
            authService.logout().then(function (r) {});
        };
    }
})();